/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export interface RequestPushNotification {
  /** 푸시 발송 요청 고유 ID */
  _id?: string;
  /** 병원 ID */
  hospitalID?: string;
  /** 병원 이벤트 ID */
  hospitalEventID?: string;
  /** 푸시 콘텐츠 타입 */
  type?: string;
  /** 푸시 코드 */
  code?: string;
  /** 푸시 제목 */
  title?: string;
  /** 푸시 내용 */
  body?: string;
  /** 푸시 발송 시 포함된 data값 */
  data?: Record<string, any>;
  /** 푸시 발송회차 */
  pushSendCount?: number;
  /** 병원 전체 / 특정 고객 발송 여부 */
  isSendToHospital?: boolean;
  /** 수신 대상자를 찾기 위한 필터 (쿼리 원형) */
  filter?: string;
  /** 조건타입 */
  filterTitle?: string;
  /** 발송 대상에 대한 상세조건 */
  filterContent?: string;
  /** 고객 가입일자 조건 */
  filterJoinedAt?: string;
  /** 발송 유저의 ObjectId */
  writerID?: string;
  /** 생성일시 */
  createdAt?: string;
  /** 수정일시 */
  updatedAt?: string;
}

export interface ResponsePushNotificationRequestPush {
  /** 푸시 발송 성공 고유 ID */
  _id?: string;
  /** 푸시 요청 ID */
  requestPushNotificationID?: RequestPushNotification;
  /** 병원 ID */
  hospitalID?: string;
  /** 병원 이벤트 ID */
  hospitalEventID?: string;
  /** 유저 ID */
  userID?: string;
  /** 서비스 ID */
  hserviceID?: string;
  /** 토큰값 */
  token?: string;
  /** 푸시 제목 */
  title?: string;
  /** 푸시 내용 */
  body?: string;
  /** 푸시 발송 상태 */
  status?: string;
  /** fcm 에러 메시지 */
  error?: string;
  /** 푸시 수신 기기 OS 타입 */
  OS?: string;
  /** (모바일) OS 버전 */
  version?: string;
  /** (웹) os 종류 및 버전 */
  osType?: string;
  /** (모바일) 기기 모델명 */
  deviceName?: string;
  /** (모바일) 앱 버전 */
  appVersion?: string;
  /** 생성일시 */
  createdAt?: string;
  /** 수정일시 */
  updatedAt?: string;
}

export interface FCMTokenHmUpdateDeviceInfoHandlerBodyRequest {
  /** 사용자의 OS 정보 - Web, iOS, Android */
  OS?: string;
  /** OS 버전 정보 - 15.2, 16.5, 18.1, ..., 26, 30, 35 등 */
  version?: string;
  /** 디바이스의 이름 */
  deviceName?: string;
  /** PWA App 버전 정보 */
  appVersion?: string;
  /** 발급된 firebase token */
  fcmToken: string;
}

export interface FCMTokenHmUpdateDeviceInfoHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 유저 ID */
    userID: string;
    /** 발급된 firebase token */
    token: string;
    /** 사용자의 OS 정보 - Web, iOS, Android */
    OS?: string;
    /** OS 버전 정보 - 15.2, 16.5, 18.1, ..., 26, 30, 35 등 */
    version?: string;
    /** 디바이스의 이름 */
    deviceName?: string;
    /** PWA App 버전 정보 */
    appVersion?: string;
    /** 토큰이 발급된 앱 종류 */
    appType?: string;
    /** 삭제 여부 */
    isRemoved?: boolean;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
    /** @format date */
    removedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ApiPushRequestElFindParams {
  /** (required) 병원 ID */
  hospitalID: string;
  /**
   * (required) 푸시 콘텐츠 타입
   * @default "HospitalEvent"
   */
  type: string;
  /** (optional) 특정 병원 이벤트로 조회 시 입력 */
  hospitalEventID?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** key option */
  key?: string;
  /** way option */
  way?: number;
}

export type ApiPushRequestElFindData = ApiResponse & {
  data: RequestPushNotification[];
};

export interface ApiPushRequestElCountParams {
  /** (required) 병원 ID */
  hospitalID: string;
  /**
   * (required) 푸시 콘텐츠 타입
   * @default "HospitalEvent"
   */
  type: string;
  /** (optional) 특정 병원 이벤트로 조회 시 입력 */
  hospitalEventID?: string;
}

export type ApiPushRequestElCountData = ApiResponse & {
  data: number;
};

export type ApiPushRequestElCreateData = ApiResponse & {
  data: RequestPushNotification;
};

export interface ApiPushResponseElFindParams {
  /** (required) 병원 서비스 ID */
  hserviceID: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type ApiPushResponseElFindData = ApiResponse & {
  data: ResponsePushNotificationRequestPush[];
};

export type FcmTokenHmUpdateDeviceInfoHandlerData = FCMTokenHmUpdateDeviceInfoHandlerResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * No description
     *
     * @tags V3-Push-RequestPushNotification
     * @name ApiPushRequestElFind
     * @summary 푸시 발송 요청 조회
     * @request GET:/v3/api/push/request/el/find
     * @secure
     * @response `200` `ApiPushRequestElFindData` \[\{RequestPushNotification\}\] 입력한 hospitalID, type에 대한 RequestPushNotification 컬렉션 객체 배열
     */
    apiPushRequestElFind: (query: ApiPushRequestElFindParams, params: RequestParams = {}) =>
      this.request<ApiPushRequestElFindData, any>({
        path: `/v3/api/push/request/el/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Push-RequestPushNotification
     * @name ApiPushRequestElCount
     * @summary 푸시 발송 요청 수 조회
     * @request GET:/v3/api/push/request/el/count
     * @secure
     * @response `200` `ApiPushRequestElCountData` \[\{RequestPushNotification\}\] 입력한 hospitalID, type에 대한 RequestPushNotification 컬렉션 객체 배열
     */
    apiPushRequestElCount: (query: ApiPushRequestElCountParams, params: RequestParams = {}) =>
      this.request<ApiPushRequestElCountData, any>({
        path: `/v3/api/push/request/el/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Push-RequestPushNotification
     * @name ApiPushRequestElCreate
     * @summary 푸시 발송 요청 생성
     * @request POST:/v3/api/push/request/el/create
     * @secure
     * @response `200` `ApiPushRequestElCreateData` \{RequestPushNotification\} 생성된 푸시 발송 요청 객체
     */
    apiPushRequestElCreate: (
      data: {
        /**
         * (required) 푸시 콘텐츠 타입
         * @default "HospitalEvent"
         */
        type: string;
        /** (required) 병원 ObjectId */
        hospitalID: string;
        /** (required) 병원 이벤트 ObjectId */
        hospitalEventID: string;
        /** (required) 병원 내 고객에게 전체 발송 여부. false 시 필터 필요 */
        isSendToHospital: boolean;
        treatmentCategories?: string[];
        isFirstVisit?: boolean[];
        /**
         * 가입 기간 시작 날짜
         * @default "2024-01-01T00:00:00.000+0900"
         */
        startDate?: string;
        /**
         * 가입 기간 종료 날짜
         * @default "2024-01-31T00:00:00.000+0900"
         */
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiPushRequestElCreateData, any>({
        path: `/v3/api/push/request/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Push-ResponsePushNotification
     * @name ApiPushResponseElFind
     * @summary 푸시 발송 성공 조회 - 여러개 보내진 경우 하나만 표시
     * @request GET:/v3/api/push/response/el/find
     * @secure
     * @response `200` `ApiPushResponseElFindData` \[\{ResponsePushNotification\}\] 입력한 hserviceID에 대한 ResponsePushNotification 컬렉션 객체 배열
     */
    apiPushResponseElFind: (query: ApiPushResponseElFindParams, params: RequestParams = {}) =>
      this.request<ApiPushResponseElFindData, any>({
        path: `/v3/api/push/response/el/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 상담 모바일 앱 - FCM 토큰 정보 업데이트
     *
     * @tags V3-Push-FCMToken
     * @name FcmTokenHmUpdateDeviceInfoHandler
     * @summary 병원 상담 모바일 앱 - FCM 토큰 정보 업데이트: ts
     * @request POST:/v3/api/push/fcmtoken/hm/update/deviceinfo
     * @secure
     * @response `200` `FcmTokenHmUpdateDeviceInfoHandlerData` success
     */
    fcmTokenHmUpdateDeviceInfoHandler: (
      data: FCMTokenHmUpdateDeviceInfoHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<FcmTokenHmUpdateDeviceInfoHandlerData, any>({
        path: `/v3/api/push/fcmtoken/hm/update/deviceinfo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
